import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "settings-wrap" }
const _hoisted_2 = {
  class: "settings-rail",
  role: "navigation",
  "aria-label": "Settings"
}
const _hoisted_3 = { class: "settings-panel" }
const _hoisted_4 = {
  key: 0,
  class: "settings-desc"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: link.to,
          to: link.to,
          class: _normalizeClass(['settings-rail-item', { on: _ctx.$route.path == link.to }])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_svg_icon, {
              icon: link.icon
            }, null, 8, ["icon"]),
            _createTextVNode(_toDisplayString(link.label), 1)
          ]),
          _: 2
        }, 1032, ["to", "class"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.desc)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.desc), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}